<template>
  <layout>
    <template #search>
      <div class="search-box">
        <Input class="search-input-warp" v-model="name" placeholder="请输入域名，每行一个域名；支持字符为英文、数字、中文、“-”；“-”不能出现在域名首尾，且不能连续出现；如输入后缀将被自动忽略；" clearable style="width: 1010px;" />
        <Button class="search-btn-warp" type="primary" icon="ios-search" @click="onSearch">查 询</Button>
      </div>
    </template>
    <div class="">
      <!-- 活动 -->
      <template v-if="activeShow">
         <div class="price-box">
          <div class="title">{{ activeList.title }}</div>
         </div>
         <div class="active-wrap">
            <img class="activeImg" :src="activeList.imgUrl" alt="">
            <div class="active-text">
                <div class="c-5 f-14">{{ activeList.linkUrl }}</div>
            </div>
         </div>
      </template>

      <div class="price-box">
        <div class="title">域名购买，买越多省越多</div>
        <div class="sub-title">信息时代的标识域名，信息就是财富！批量域名注册、轻松搞定域名转入，众多后缀优惠供您选择！</div>
      </div>
      <div class="domain-price-box">
        <div class="domain-price">
          <div class="price-cover">
            <img class="price-cover-img" src="@/assets/image/price-1.png" alt="" srcset="" />
            <div class="price-cover-tips">
              <div class="title">域名注册</div>
              <div class="stitle">首年注册</div>
              <router-link class="more" :to="{path: '/price', query: { type: 0}}">查看更多 ></router-link>
            </div>
          </div>
          <div class="price-content">
            <div class="price-item" v-for="item in priceObj.priceList0" :key="item.id">
              <div class="title">{{item.suffix}}</div>
              <div class="desc">{{item.desc}}</div>
              <div class="b-price">{{item.list[0].activityPrice || item.list[0].price }}</div>
            </div>
          </div>
        </div>
        <div class="domain-price">
          <div class="price-cover">
            <img class="price-cover-img" src="@/assets/image/price-2.png" alt="" srcset="" />
            <div class="price-cover-tips">
              <div class="title">续费价格</div>
              <div class="stitle">单年续费价格</div>
              <router-link class="more" :to="{path: '/price', query: { type: 1}}">查看更多 ></router-link>
            </div>
          </div>
          <div class="price-content">
            <div class="price-item" v-for="item in priceObj.priceList1" :key="item.id">
              <div class="title">{{item.suffix}}</div>
              <div class="desc">{{item.desc}}</div>
              <div class="b-price">{{item.list[0].activityPrice || item.list[0].price }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="domain-price-section">
        <div class="first-box">
          <div class="title">转入价格</div>
          <div class="stitle">首年注册</div>
          <router-link class="more" :to="{path: '/price', query: { type: 2}}">查看更多 ></router-link>
        </div>
        <div class="domain-price-content">
          <div class="price-content">
            <div class="price-item" v-for="item in priceObj.priceList2" :key="item.id">
              <div class="title">{{item.suffix}}</div>
              <div class="desc">{{item.desc}}</div>
              <div class="b-price">{{item.list[0].activityPrice || item.list[0].price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="warning-box">
      <div style="margin-right: 40px;">注意事项</div>
      <div>
        <div class="text">1、注册域名请先阅读：
          <span @click="regModel" style="cursor:pointer">《域见未来域名注册服务协议》</span>、
          <span @click="renewServiceModelShow = true" style="cursor:pointer">《域见未来域名续费服务协议》</span>
<!--          <span @click="templateServiceModelShow = true" style="cursor:pointer">《域见未来域名模板服务协议》</span>-->
          </div>
        <div class="text">2、CN域名注册后要经过CNNIC审核，如果审核不通过，则域名注册会被退回。</div>
      </div>
    </div>
    <!-- 域见未来域名注册服务协议 -->
    <rule-modal
      :show.sync="RulesModelShow"
      :content="RulesContent"
      :title="RulesTitle"
    ></rule-modal>
    <!-- 域见未来域名续费服务协议 -->
    <rule-modal
      :show.sync="renewServiceModelShow"
      :content="renewServiceContent"
      :title="renewServiceTitle"
    ></rule-modal>
    <rule-modal
        :show.sync="templateServiceModelShow"
        :content="templateServiceContent"
        :title="templateServiceTitle"
    ></rule-modal>
  </layout>


</template>
<script>
import templateRules from "@/assets/rule/templateRules";
import layout from "./components/layout.vue";
import ruleModal from "components/ruleModal.vue";
// import domainNameRegisterRules from "assets/rule/domainNameRegisterRules";
import { getDomainSuffix, getPriceList, getActivity, agreementList } from "api/domain.js";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "index",
  data() {
    return {
      bg: require("../../assets/image/banner.png"),
      name: "",
      sufList: [],
      priceObj: {
        priceList0: [],
        priceList1: [],
        priceList2: [],
      },
      RulesModelShow:false,
      RulesContent:'',
      RulesTitle:'',
      renewServiceModelShow: false,
      renewServiceContent: '',
      renewServiceTitle: '',

      activeShow:true,
      activeList:{},
      templateServiceModelShow: false,
      templateServiceContent: '',
      templateServiceTitle: '',
    };
  },
  components: {
    layout,
    ruleModal
  },
  computed: {
    ...mapState(["domainQueryData"]),
    domainSuffix(){
      return this.domainQueryData.domainSuffix.length > 0 ? this.domainQueryData.domainSuffix : [];
    },
  },
  created() {
    if (this.domainQueryData.domainSuffix.length === 0) {
      this.ACT_DOMAIN_QUERY();
    }
    this.req_getPriceList(0);
    this.req_getPriceList(1);
    this.req_getPriceList(2);
    this.getActivityList()
    this.getAgreementList()

    this.templateServiceTitle = templateRules.title;
    this.templateServiceContent = templateRules.content;
  },
  methods: {
    ...mapActions(["ACT_DOMAIN_QUERY"]),
    ...mapMutations(["MUT_TOKEN_INFO"]),
    regModel() {
      this.RulesModelShow = true;
      // if (!this.RulesContent) {
      //   this.RulesContent = domainNameRegisterRules.content;
      //   this.RulesTitle = domainNameRegisterRules.title;
      // }
    },
    req_getDomainSuffix() {
      getDomainSuffix().then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.sufList = data;
        }
      });
    },
    req_getPriceList(type) {
      getPriceList(type).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          if(data.length > 4){
            this.priceObj[`priceList${type}`] = data.splice(0,4);
          }else{
            this.priceObj[`priceList${type}`] = data;
          }
        }
      });
    },
    getAgreementList(){
      agreementList([1,2]).then((res) => {
              const { code, data } = res;
              if(code === 200 && data.length>0){
                this.RulesContent = data[0].content
                this.RulesTitle = data[0].name
                this.renewServiceContent = data[1].content
                this.renewServiceTitle = data[1].name
              }
      });
    },
    onSearch() {
      this.$router.push({ path: "/search", query: { name: this.name.replace(/\s*/g,'') } });
    },
    async getActivityList(){
      const { code, data } = await getActivity()
      if (code == 200) {
        if(data.bannerList.length>0){
           this.activeShow = true
           this.activeList = data.bannerList[0]
        }else{
          this.activeShow = false
        }
      }
    }
  },
};
</script>
<style lang="less" scoped>
.domain-F6F6F6{
  background-color: #F6F6F6;
  padding: 25px 0;
  .domain-type-box{
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    padding: 25px;
    border-radius: 8px;
    .domain-type-title{
      line-height: 30px;
    }
    .checkbox-type ::v-deep {
      .ivu-checkbox-wrapper-checked.ivu-checkbox-border{
        border-color: #F85936;
      }
      ::v-deep .ivu-checkbox-inner {
        margin-right: 3px;
      }
      ::v-deep .ivu-checkbox-focus{
        box-shadow: none;
      }
      ::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
        border-color: #F85936;
        background-color: #F85936;
        margin-right: 3px;
      }
    }
  }
}
.price-box{
  width: 1200px;
  margin: 0 auto;
  padding: 90px 0 60px;
  .title{
    font-size: 30px;
    color: #403633;
    font-weight: bold;
  }
  .sub-title{
    font-size: 14px;
    color: #959290;
    font-weight: 400;
  }
}
.active-wrap{
    width: 1200px;
    margin: 0 auto;
    .active-text{
     margin-top: 20px;
     line-height: 30px;
     text-indent: 2em;
   }
    .activeImg{
      width: 1200px;
    }
}
.domain-price-box{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .domain-price{
    flex: 0 0 589px;
    overflow: hidden;
    display: flex;
    .price-cover{
      flex: 0 0 200px;
      overflow: hidden;
      position: relative;
      font-size: 0;
      .price-cover-img{
        width: 100%;
        height: auto;
      }
      .price-cover-tips{
        position: absolute;
        left: 30px;
        top: 40px;
        .title{
          font-size: 20px;
          color: #333333;
          font-weight: bold;
        }
        .stitle{
          font-size: 14px;
          color: #999;
          margin-top: 16px;
        }
        .more{
          display: block;
          margin-top: 40px;
          color: #333333;
        }
      }
    }
    .price-content{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      .price-item{
        flex: 0 0 194px;
        border: 1px solid #EEEEEE;
        padding: 40px 30px;
        position: relative;
        &:nth-child(2n){
          margin-left: -1px;
        }
        &:nth-child(n+3){
          margin-top: -1px;
        }
        .title{
          font-size: 18px;
          color: #333;
          font-weight: bold;
        }
        .desc{
          color: #909295;
          font-size: 14px;
          margin-top: 16px;
        }
        .b-price{
          position: absolute;
          bottom: 20px;
          font-size: 30px;
          color: #F85A36;
          &::before{
            content: '￥';
            font-size: 16px;
          }
          &::after{
            content: '/ 首年起';
            font-size: 16px;
          }
        }
      }
    }

  }
}
.domain-price-section{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    height: 220px;
    margin-top: 20px;
    .first-box{
      width: 200px;
      height: 220px;
      background-color: #F0F2F5;
      padding: 30px;
      .title{
        font-size: 20px;
        color: #333333;
        font-weight: bold;
      }
      .stitle{
        font-size: 14px;
        color: #999999;
        font-weight: 400;
      }

    }
  }
  .domain-price-content{
    flex: 1;
    overflow: hidden;
    display: flex;
    .price-content{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      border-top: 1px solid #EEEEEE;
      border-bottom: 1px solid #EEEEEE;
      border-right: 1px solid #EEEEEE;
      .price-item{
        flex: 0 0 220px;
        padding: 40px 30px;
        position: relative;
        margin-right: 40px;
        &:nth-child(n+1){
          margin-left: -1px;
        }
        &:last-child{
          margin-right: 0;
        }
        .title{
          font-size: 18px;
          color: #333;
          font-weight: bold;
        }
        .desc{
          color: #909295;
          font-size: 14px;
          margin-top: 16px;
        }
        .b-price{
          position: absolute;
          bottom: 20px;
          font-size: 30px;
          color: #F85A36;
          &::before{
            content: '￥';
            font-size: 16px;
          }
          &::after{
            content: '/ 首年起';
            font-size: 16px;
          }
        }
      }
    }
  }
  .warning-box{
    width: 1200px;
    height: 100px;
    padding: 26px 38px;
    font-size: 18px;
    font-weight: Bold;
    color: #333333;
    display: flex;
    align-items: center;
    background-color: #EFE1DC;
    margin: 40px auto;
    .text{
      font-size: 14px;
      color: #403633;
      line-height: 20px;
    }
  }
  .more{
    display: block;
    font-size: 14px;
    margin-top: 50px;
    color: #333333;
  }
</style>
